/**
 * @voltxampere/ui — PAM8403 Class-D audio amplifier (Sprint 45-2, placeholder)
 *
 * PLACEHOLDER. Class-D dijital audio amp — şu anki stamp tek
 * `opamp` üzerinden gösterir; gerçek PWM modulation + LC çıkış
 * filtresi + Class-D switching efficiency Sprint 50+ engine
 * extension #4 ile aktif.
 *
 * Reference: DiodesZetex PAM8403 — SOP-16. Düşük güç Class-D
 * stereo audio amp, V_supply 2.5-5.5 V, 2×3 W @ 4 Ω, %90+
 * verim (Class-D advantage), THD 0.05% @ 1W. USB-powered
 * portable speaker + Bluetooth speaker amp + DIY desktop audio.
 *
 *   Default mapping → opamp schemaType:
 *     openLoopGain = 24        (24 dB gain ≈ 16, but use 24 estimate)
 *     poleFrequency = 100      (Class-D high-bandwidth, 100 kHz)
 *     saturationVoltage = 4    (V_supply 5V için close-to-rail)
 *
 * Engine zero-diff invariant honored — canonical `opamp` engine
 * type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const audioPam8403 = {
    id: "pam8403",
    nameTr: "PAM8403 (Class-D Stereo 2×3W, SOP-16, placeholder)",
    nameEn: "PAM8403 (Class-D Stereo 2×3W, SOP-16, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "PAM8403",
    schemaType: "opamp",
    defaultParams: { openLoopGain: 24, poleFrequency: 100, saturationVoltage: 4 },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=audio-pam8403.js.map